// import { ElevenLabsClient, play } from "elevenlabs";
// const elevenlabs = new ElevenLabsClient({
//    apiKey: "sk_b66b0f0cc68730f7a184ff4543a96e62d83be7ab4b9ebdc7",  // Replace with your ElevenLabs API key
// });
// Define the speakTextUnified function using fetch
// async function speakTextUnified(text, voiceId = "oWAxZDx7w5VEj9dCyTzz") {
// async function speakTextUnified(text, voiceId = "JBFqnCBsd6RMkjVDRZzb") {  // George
// Jörg ID GXNIlNdiZ66cesbId98C
// Albers-Online Vo6eWjeFYiXfc1vacEPz

import "./script.js";
import './styles.scss';
import { isMobileDevice } from "./script.js";
import { playAudioBlob } from "./script.js";
import { speechStatus, playbackControl, waitUntilResumed } from "./script.js";

console.log("✅ speechStatus imported in index.js:", speechStatus);

async function speakTextUnified(text, voiceId = "Vo6eWjeFYiXfc1vacEPz") {
    console.log("🗣️ Executing speakTextUnified:", text);

    const apiKey = "sk_b66b0f0cc68730f7a184ff4543a96e62d83be7ab4b9ebdc7";
    const url = `https://api.elevenlabs.io/v1/text-to-speech/${voiceId}`;

    try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "xi-api-key": apiKey,
            },
            body: JSON.stringify({
                text: text,
                model_id: "eleven_multilingual_v2",
            }),
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const audioBlob = await response.blob();
        const audioUrl = URL.createObjectURL(audioBlob);

        // ✅ Respect pause state before anything happens
        await waitUntilResumed();

        if (isMobileDevice()) {
            speechStatus.isSpeaking = true;
            await playAudioBlob(audioBlob);
            speechStatus.isSpeaking = false;
        } else {
            return new Promise((resolve, reject) => {
                const audio = new Audio(audioUrl);

                const waitToPlay = async () => {
                    await waitUntilResumed();
                    audio.play().catch(err => console.error("❌ Desktop playback failed:", err));
                };

                speechStatus.isSpeaking = true;

                waitToPlay().catch(reject); // ✅ Await async playback resume safely

                audio.onended = () => {
                    speechStatus.isSpeaking = false;
                    resolve();
                };

                audio.onerror = reject;

                setTimeout(() => {
                    if (speechStatus.isSpeaking) {
                        console.warn("⚠️ Speech timeout fallback triggered.");
                        speechStatus.isSpeaking = false;
                        resolve();
                    }
                }, 30000);
            });
        }
    } catch (error) {
        console.error("❌ Error with ElevenLabs TTS:", error);
        if (error.response) {
            console.error("Response status:", error.response.status);
            console.error("Response body:", await error.response.text());
        }
        speechStatus.isSpeaking = false;
        throw error;
    }
}

window.speakTextUnified = speakTextUnified;
